module.exports = __webpack_public_path__ + "img/skypets-6.9d496e1a.webp";